export const getSubUserRightLabel = (index: number) => {
  switch (index) {
    case 1:
      return 'Recevoir notifications'
    default:
      return 'Aucun droit'
  }
}

export const subUserENTRightsList = [
  'notifications',
  // 'login'
]